import React from "react";
import { ActionIcon } from "rizzui/action-icon";
import { HiOutlinePlayCircle } from "react-icons/hi2";
import { PiPauseCircle } from "react-icons/pi";
import { GoMute } from "react-icons/go";
import { Text } from "rizzui/typography";
import SpeakerIcon from "../assets/speaker";
import { Loader } from "rizzui/loader";

export default function CallRecording({
  isPlaying,
  currentTime,
  duration,
  volume,
  onPlayPause,
  onMute,
  waveformRef,
}) {
  const formatTime = (seconds: number = 0) =>
    [seconds / 60, seconds % 60]
      .map((v) => `0${Math.floor(v)}`.slice(-2))
      .join(":");

  return (
    <div className="!h-[42px] grid grid-cols-12 bg-[#3B434D] rounded-[50px] content-center px-[3px]">
      <div className="col-span-4 flex flex-row items-center">
        <ActionIcon
          className="!bg-transparent rounded-full"
          onClick={onPlayPause}
        >
          {isPlaying ? (
            <PiPauseCircle size={27} fill="#C3DEFF" strokeWidth={1} />
          ) : (
            <HiOutlinePlayCircle size={27} stroke="#C3DEFF" strokeWidth={1} />
          )}
        </ActionIcon>
        <Text className="font-switzer font-[400] text-[12px] leading-[15.84px] text-[#758599]">
          {formatTime(currentTime)}/{formatTime(duration)}
        </Text>
      </div>
      <div ref={waveformRef} className="col-span-6 content-center"></div>
      <div className="col-span-2 h-fit flex flex-row justify-center">
        <ActionIcon className="!bg-transparent rounded-full" onClick={onMute}>
          {volume === 0 ? (
            <GoMute size={24} fill="#C3DEFF" />
          ) : (
            <SpeakerIcon className={""} />
          )}
        </ActionIcon>
      </div>
    </div>
  );
}
